import "./FormDir.scss";
import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Button, Col, Form, Row, Spin, notification, Table, Icon, Radio, Divider } from "antd";
import { FormLayout } from "../../../../../layouts";
import { withRouter } from "../../../../../helpers/withRouter";
import { getFormPromise, getParamsPromise } from "../../../promises";
import moment from "moment";
import Logo from '../../../../../layouts/commonComponent/components/Logo/Logo'
import { getCountriesCodePromise } from "../../../../OnBoarding/promises";
import apiConfig from '../../../../../config/api'
import {getOptList} from "../assets/optList";
import useFormsHooks from "../../hooks/useFormsHooks";

const FormDir = ({ form, match }) => {
  const { t, i18n } = useTranslation(["forms", "formsSonda"]);
  const optList = getOptList()
  
  const { getFieldsError, validateFieldsAndScroll, setFields } = form;
  const [isValidate, setIsValidate] = useState(true);
  const [isLoading, setIsloading] = useState(true);
  const [paises, setPaises] = useState(null);
  const [date, setDate] = useState(0);
  const [signed, setSigned] = useState(false);
  const [user, setUser] = useState({});
  const [apiForm, _setApiForm] = useState(null);
  const [colLogo, setColLogo] = useState(4);
  const [format, setFormat] = useState("html");
  const [openSigner, setOpenSigner] = useState(false);
  const hasSign = false
  const [clientName, setClientName] = useState("");
  const [signData, setSignData] = useState(null);
  const apiFormRef = useRef(apiForm);
  const [validarRegistros, setValidarRegistros] = useState(false);
  const [empresasGrupo, setEmpresasGrupo] = useState([]);
  const [registerData, setRegisterData] = useState();

  const setApiForm = data => {
    apiFormRef.current = data;
    _setApiForm(data);
  };

  const handlerOnChangeObjAttr = async (sectionId, value, formObj) => {
    handleOnChangeField(sectionId, value)
    const binfo = entriesToObj(basicInformation)
    const iMall = entriesToObj(mallaParental)
    const iPsoc = entriesToObj(participacionSociedades)
    const iPemp = entriesToObj(participacionEmpresa);
    const inter = entriesToObj(interlocking);
    const iFuerHor = entriesToObj(fueraDeHorario);    
    const iEmpleosAnt = entriesToObj(empleosAnteriores);
    const iRelComp = entriesToObj(relacionCompetencia);
    const iFuncPub = entriesToObj(funcionariosPublicos);
    const iRelFund = entriesToObj(relacionFundaciones);

    if(!formObj) formObj = apiForm
    const json = { 
      basicInformation: binfo,
      mallaParental: iMall, 
      participacionSociedades: iPsoc, 
      participacionEmpresa: iPemp,
      interlocking: inter,
      fueraDeHorario: iFuerHor,
      empleosAnteriores: iEmpleosAnt,
      relacionCompetencia: iRelComp,
      funcionariosPublicos: iFuncPub,
      relacionFundaciones: iRelFund,
    }
    let formToUpdate = { ...formObj, json };
    let ret = await saveFormPromiseLocal(formToUpdate);
    if(!ret.success) {
    //  setFieldsValue({[field]: ret.form[field]})
    }
  }

  const initVariablesFromObject = (obj, objs={}) => {
    let objs1 = {...objs}
    if (obj.json) {
      if (obj.json.basicInformation) {
        let binfo = objToVariable(basicInformationIS, obj.json.basicInformation);
        objs1['basicInformation'] = binfo
      }
      if (obj.json.mallaParental) {
        let iMall = objToVariable(mallaParentalIS, obj.json.mallaParental);
        objs1['mallaParental'] = iMall
      }
      if (obj.json.participacionSociedades) {
        let partSoc = objToVariable(participacionSociedadesIS, obj.json.participacionSociedades);
        objs1['participacionSociedades'] = partSoc
      }
      if (obj.json.participacionEmpresa) {
        let partEmp = objToVariable(participacionEmpresaIS, obj.json.participacionEmpresa);
        objs1['participacionEmpresa']= partEmp
      }
      if (obj.json.interlocking) {
        let interlock = objToVariable(interlockingIS, obj.json.interlocking);
        objs1['interlocking'] = interlock
      }
      if (obj.json.fueraDeHorario) {
        let fuerHor = objToVariable(fueraDeHorarioIS, obj.json.fueraDeHorario);
        objs1['fueraDeHorario'] = fuerHor
      }
      if (obj.json.empleosAnteriores) {
        let empleosAnt = objToVariable(empleosAnterioresIS, obj.json.empleosAnteriores);
        objs1['empleosAnteriores'] = empleosAnt
      }
      if (obj.json.relacionCompetencia) {
        let relComp = objToVariable(relacionCompetenciaIS, obj.json.relacionCompetencia);
        objs1['relacionCompetencia'] = relComp
      }
      if (obj.json.funcionariosPublicos) {
        let funcPub = objToVariable(funcionariosPublicosIS, obj.json.funcionariosPublicos);
        objs1['funcionariosPublicos'] = funcPub
      }
      if (obj.json.relacionFundaciones) {
        let relFund = objToVariable(relacionFundacionesIS, obj.json.relacionFundaciones);
        objs1['relacionFundaciones'] = relFund
      }
    }
    registerObjSections(objs1)
  };

  const { getObjSection, 
    registerObjSections, 
    handleOnChangeFields, 
    handleOnChangeField, 
    renderFormItem, 
    renderFormItemTable, 
    renderFormItemObj, 
    objToVariable, 
    toCamelCase, 
    handleOnClear, 
    handleDeleteAttrTable, 
    handleOnAddAttrTable, 
    entriesToObj, 
    saveFormPromiseLocal, 
    sendDocument, 
    docValidator, 
    toDescriptionsPdf 
  } = useFormsHooks({format, form, match, apiForm, setApiForm, handlerOnChangeObjAttr, initVariablesFromObject, optList});

  let registersStop = {};

  const radioStyle = {
    display: 'block',
    height: '22px',
    lineHeight: '22px',
    pointerEvents: format === 'pdf' ? 'none' : 'auto'
  };

  // INTRODUCCION
  const basicInformationIS= {
    gerencia: { key: "gerencia", size: "small", placeholder: t("forms.placeholder.ingrese_gerencia"), maxLength:100, id: "basicInformationGerencia", required: true, type: 'input', itemClassName: "introduccion-item"},
    cargo: { key: "cargo", size: "small", placeholder:"Ingrese Cargo", maxLength:100, id: "basicInformationCargo", required: true, type: 'input'},
    fechaContratacion: { key: "fechaContratacion", size: "small", placeholder: "", id: "basicInformationFechaContratacion", required: true, type: 'date'},
  };
  const [keyBasicInformation, basicInformation] = getObjSection('basicInformation')

  // MALLA PARENTAL
  const mallaParentalIS= {
    records: { key: "records", val: [], id: "mallaParentalRecords"},
  };
  const [keyMallaParental, mallaParental] = getObjSection('mallaParental')


  const mallaParObjIS = {
    parentesco: { key: "parentesco", title: t("forms.label.parentesco"), id: "mallaParObjParentesco", required: true, type: 'select' },
    nombre:     { key: "nombre",     title: t("forms.label.nombre"),     maxLength:100, id: "mallaParObjNombre",     required: true, type: 'input'  },
    tipoDoc:    { key: "tipoDoc",    title: t("forms.label.tipoDoc"),    id: "mallaParObjTipoDoc",     required: true, type: 'select' },
    doc:        { key: "doc",        title: t("forms.label.doc"),       maxLength:50,  id: "mallaParObjDoc",       required: true, type: 'input'  },
  };
  const [keyMallaParObj, mallaParObj] = getObjSection('mallaParObj')

  // PARTICIPACION EN SOCIEDADES
  const participacionSociedadesIS= {
    hasRecords: { key: "hasRecords", val: undefined, title: "", id: "participacionSociedadesHasPsoc", required: true},
    records: { key: "records", val: [], id: "participacionSociedadesRecords"},
  };
  const [keyParticipacionSociedades, participacionSociedades] = getObjSection('participacionSociedades')

  const dataPsocObjIS = {
    razonSocial:            { key: "razonSocial",            title: t("forms.label.razonSocial"),            maxLength:100, id: "dataPsocObjRazonSocial",            required: true, type: 'input'  },
    tipoDocEmp:             { key: "tipoDocEmp",             title: t("forms.label.tipoDoc"),             id: "dataPsocObjTipoDocEmp",             required: true, type: 'select' },
    docEmp:                 { key: "docEmp",                 title: t("forms.label.docEmp"),                 maxLength:50, id: "dataPsocObjDocEmp",                 required: true, type: 'input' },
    paisEmp:                { key: "paisEmp",                title: t("forms.label.paisEmp"),                id: "dataPsocObjPais",                  required: true, type: 'select' },
    parentesco:             { key: "parentesco",             title: t("forms.label.parentesco"),             id: "dataPsocObjParentesco",             required: true, type: 'select' },
    nombre:                 { key: "nombre",                 title: t("forms.label.nombre"),                 maxLength:100, id: "dataPsocObjNombre",                 required: true, type: 'input'  },
    tipoDoc:                { key: "tipoDoc",                title: t("forms.label.tipoDoc"),                id: "dataPsocObjTipoDoc",                required: true, type: 'select' },
    doc:                    { key: "doc",                    title: t("forms.label.doc"),                    maxLength:50, id: "dataPsocObjDoc",                    required: true, type: 'input'  },
    cargoOpt:                  { key: "cargoOpt",                  title: t("forms.label.cargo"),                  id: "dataPsocObjCargoOpt",                  required: true, type: 'select' },
    tipoPropiedad:          { key: "tipoPropiedad",          title: t("forms.label.tipoPropiedad"),          id: "dataPsocObjTipoPropiedad",          required: true, type: 'select' },
    porcentajeParticipacion:{ key: "porcentajeParticipacion",title: t("forms.label.porcentajeParticipacion"),id: "dataPsocObjPorcentajeParticipacion",required: true, type: 'number', isPercentage: true, max: 100 },
    nombreEmpIndirecta:     { key: "nombreEmpIndirecta",     title: t("forms.label.nombreEmpIndirecta"),     maxLength:100, id: "dataPsocObjNombreEmpIndirecta",     required: true, type: 'input' },
    tipoDocEmpIndirecta:    { key: "tipoDocEmpIndirecta",    title: t("forms.label.tipoDocEmpIndirecta"),    id: "dataPsocObjTipoDocEmpIndirecta",    required: true, type: 'select' },
    docEmpIndirecta:        { key: "docEmpIndirecta",        title: t("forms.label.docEmpIndirecta"),        maxLength:50, id: "dataPsocObjDocEmpIndirecta",        required: true, type: 'input' },
    otroCargo:              { key: "otroCargo",              title: t("forms.label.otroCargo"),              maxLength:50, id: "dataPsocObjOtroCargo",              required: true, type: 'input' },
  };
  const [keyDataPsocObj, dataPsocObj] = getObjSection('dataPsocObj')

  // PARTICIPACION EN PROPIEDAD DE LA EMPRESA
  const participacionEmpresaIS= {
    hasRecords: { key: "hasRecords", val: undefined, title: "", id: "participacionEmpresaHasPemp", required: true},
    records: { key: "records", val: [], id: "participacionEmpresaRecords"},
  };
  const [keyParticipacionEmpresa, participacionEmpresa] = getObjSection('participacionEmpresa')

  const dataPempObjIS = {
    parentesco:            { key: "parentesco",            title: t("forms.label.parentesco"),            id: "dataPempObjParentesco",            required: true, type: 'select' },
    nombre:                { key: "nombre",                title: t("forms.label.nombre"),                maxLength:100, id: "dataPempObjNombre",                required: true, type: 'input'  },
    tipoDoc:               { key: "tipoDoc",               title: t("forms.label.tipoDoc"),               id: "dataPempObjTipoDoc",               required: true, type: 'select' },
    doc:                   { key: "doc",                   title: t("forms.label.doc"),                   maxLength:50, id: "dataPempObjDoc",                   required: true, type: 'input'  },
    grupo:                 { key: "grupo",                 title: t("forms.label.grupo"),                 id: "dataPempObjGrupo",                 required: true, type: 'select' },
    cargoOpt:                 { key: "cargoOpt",                 title: t("forms.label.cargo"),                 id: "dataPempObjCargoOpt",                 required: true, type: 'select' },
    tipoPropiedad:         { key: "tipoPropiedad",         title: t("forms.label.tipoPropiedad"),         id: "dataPempObjTipoPropiedad",         required: true, type: 'select' },
    porcentajeParticipacion:{ key: "porcentajeParticipacion",title: t("forms.label.porcentajeParticipacion"),id: "dataPempObjPorcentajeParticipacion",required: true, type: 'number', isPercentage: true, max: 100 },
    nombreEmpIndirecta:    { key: "nombreEmpIndirecta",    title: t("forms.label.nombreEmpIndirecta"),    maxLength:100, id: "dataPempObjNombreEmpIndirecta",    required: true, type: 'input' },
    tipoDocEmpIndirecta:   { key: "tipoDocEmpIndirecta",   title: t("forms.label.tipoDocEmpIndirecta"),   id: "dataPempObjTipoDocEmpIndirecta",   required: true, type: 'select' },
    docEmpIndirecta:       { key: "docEmpIndirecta",       title: t("forms.label.docEmpIndirecta"),       maxLength:50, id: "dataPempObjDocEmpIndirecta",       required: true, type: 'input' },
    otroCargo:              { key: "otroCargo",              title: t("forms.label.otroCargo"),              maxLength:50, id: "dataPempObjOtroCargo",              required: true, type: 'input' },
  };
  const [keyDataPempObj, dataPempObj] = getObjSection('dataPempObj')

  // INTERLOCKING
const interlockingIS = {
  hasRecords: { key: "hasRecords", val: undefined, title: "", id: "interlockingHasInterlocking", required: true },
  records: { key: "records", val: [], id: "interlockingRecords" },
};
const [keyInterlocking, interlocking] = getObjSection('interlocking')

const interObjIS = {
  razonSocial:             { key: "razonSocial",             title: t("forms.label.razonSocial"),             maxLength:100, id: "interObjRazonSocial",             required: true, type: 'input' },
  tipoDoc:                 { key: "tipoDoc",                 title: t("forms.label.tipoDoc"),                 id: "interObjTipoDoc",                 required: true, type: 'select' },
  doc:                     { key: "doc",                     title: t("forms.label.doc"),                     maxLength:50, id: "interObjDoc",                     required: true, type: 'input' },
  fechaIngreso:            { key: "fechaIngreso",            title: t("forms.label.fechaIngreso"),            id: "interObjFechaIngreso",            required: true, type: 'date' },
  fechaTermino:            { key: "fechaTermino",            title: t("forms.label.fechaTermino"),            id: "interObjFechaTermino",            required: false, type: 'date' },
  cargoInterlocking:                   { key: "cargoInterlocking",                   title: t("forms.label.cargo"),                   maxLength:200, id: "interObjCargoInterlocking",                   required: true, type: 'select' },
  cargoEjecutivoRelevante: { key: "cargoEjecutivoRelevante", title: t("forms.label.cargoEjecutivoRelevante"), maxLength:200, id: "interObjCargoEjecutivoRelevante", required: true, type: 'input' },
};

const [keyInterObj, interObj] = getObjSection('interObj')

// ACTIVIDADES FUERA DE LA EMPRESA
const fueraDeHorarioIS= {
  hasRecords: { key: "hasRecords", val: undefined, title: "", id: "fueraDeHorarioHasActFueraHorario", required: true},
  records: { key: "records", val: [], id: "fueraDeHorarioRecords"},
};
const [keyFueraDeHorario, fueraDeHorario] = getObjSection('fueraDeHorario')

const actFueraObjIS = {
  razonSocial: { key: "razonSocial", title: t("forms.label.razonSocial"), maxLength:100, id: "actFueraObjRazonSocial", required: true, type: 'input' },
  tipoDocEmp:  { key: "tipoDocEmp",  title: t("forms.label.tipoDoc"),  id: "actFueraObjTipoDocEmp",  required: true, type: 'select' },
  docEmp:      { key: "docEmp",      title: t("forms.label.docEmp"),      maxLength:50, id: "actFueraObjDocEmp",      required: true, type: 'input' },
  actividad:   { key: "actividad",   title: t("forms.label.actividad"),   maxLength:100, id: "actFueraObjActividad", required: true, type: 'input' },
};
const [keyActFueraObj, actFueraObj] = getObjSection('actFueraObj')

// RELACIONES LABORALES ANTERIORES
const empleosAnterioresIS= {
  hasRecords: { key: "hasRecords", val: undefined, title: "", id: "empleosAnterioresHasEmpleosAnteriores", required: true},
  records: { key: "records", val: [], id: "empleosAnterioresRecords"},
};
const [keyEmpleosAnteriores, empleosAnteriores] = getObjSection('empleosAnteriores')

const empleosAntObjIS = {
  razonSocial:  { key: "razonSocial",  title: t("forms.label.razonSocial"),  maxLength:100, id: "empleosAntObjRazonSocial",  required: true, type: 'input' },
  tipoDocEmp:   { key: "tipoDocEmp",   title: t("forms.label.tipoDoc"),   id: "empleosAntObjTipoDocEmp",   required: true, type: 'select' },
  docEmp:       { key: "docEmp",       title: t("forms.label.docEmp"),       maxLength:50, id: "empleosAntObjDocEmp",       required: true, type: 'input' },
  cargo:        { key: "cargo",        title: t("forms.label.cargoEjercido"), maxLength:100, id: "empleosAntObjCargo",       required: true, type: 'input' },
  fechaIngreso: { key: "fechaIngreso", title: t("forms.label.fechaIngreso"), id: "empleosAntObjFechaIngreso", required: true, type: 'date' },
  fechaTermino: { key: "fechaTermino", title: t("forms.label.fechaTermino"), id: "empleosAntObjFechaTermino", required: true, type: 'date' },
};
const [keyEmpleosAntObj, empleosAntObj] = getObjSection('empleosAntObj')

// RELACION CON LA COMPETENCIA
const relacionCompetenciaIS= {
  hasRecords: { key: "hasRecords", val: undefined, title: "", id: "relacionCompetenciaHasCompetencia", required: true},
  records: { key: "records", val: [], id: "relacionCompetenciaRecords"},
};
const [keyRelacionCompetencia, relacionCompetencia] = getObjSection('relacionCompetencia')

const dataCompObjIS = {
  razonSocial: { key: "razonSocial", title: t("forms.label.razonSocial"), maxLength:100, id: "dataCompObjRazonSocial", required: true, type: 'input' },
  tipoDocEmp:  { key: "tipoDocEmp",  title: t("forms.label.tipoDoc"),  id: "dataCompObjTipoDocEmp",  required: true, type: 'select' },
  docEmp:      { key: "docEmp",      title: t("forms.label.docEmp"),      maxLength:50, id: "dataCompObjDocEmp",     	required: true, type: 'input' },
  parentesco:  { key: "parentesco",  title: t("forms.label.parentesco"),  id: "dataCompObjParentesco", required: true, type: 'select' },
  nombre:      { key: "nombre",      title: t("forms.label.nombre"),      maxLength:100, id: "dataCompObjNombre",      required: true, type: 'input' },
  tipoDoc:     { key: "tipoDoc",     title: t("forms.label.tipoDoc"),     id: "dataCompObjTipoDoc",     required: true, type: 'select' },
  doc:         { key: "doc",         title: t("forms.label.doc"),         maxLength:50, id: "dataCompObjDoc",         required: true, type: 'input' },
  cargo:       { key: "cargo",       title: t("forms.label.cargoEmpCompetidora"),       maxLength:100, id: "dataCompObjCargo",       required: true, type: 'input' },
};
const [keyDataCompObj, dataCompObj] = getObjSection('dataCompObj')


// FUNCIONARIOS PUBLICOS O PERSONAS EXPUESTAS POLÍTICAMENTE
const funcionariosPublicosIS= {
  hasRecords: { key: "hasRecords", val: undefined, title: "", maxLength:200, id: "funcionariosPublicosHasPep", required: true},
  records: { key: "records", val: [], id: "funcionariosPublicosRecords"},
};
const [keyFuncionariosPublicos, funcionariosPublicos] = getObjSection('funcionariosPublicos')

const dataPepObjIS = {
  categoria:    { key: "categoria",    title: t("forms.label.categoria"),    id: "dataPepObjCategoria",    required: true, type: 'select' },
  razonSocial:  { key: "razonSocial",  title: t("forms.label.institucion"),  maxLength:100, id: "dataPepObjRazonSocial",  required: true, type: 'input' },
  parentesco:   { key: "parentesco",   title: t("forms.label.parentesco"),   id: "dataPepObjParentesco",   required: true, type: 'select' },
  nombre:       { key: "nombre",       title: t("forms.label.nombre"),       maxLength:100, id: "dataPepObjNombre",       required: true, type: 'input' },
  tipoDoc:      { key: "tipoDoc",      title: t("forms.label.tipoDoc"),      id: "dataPepObjTipoDoc",      required: true, type: 'select' },
  doc:          { key: "doc",          title: t("forms.label.doc"),          maxLength:50, id: "dataPepObjDoc",          required: true, type: 'input' },
  cargo:        { key: "cargo",        title: t("forms.label.cargo"),        maxLength:100, id: "dataPepObjCargo",        required: true, type: 'input' },
  fechaTermino: { key: "fechaTermino", title: t("forms.label.fechaTermino"), id: "dataPepObjFechaTermino", required: false, type: 'date' },
};
const [keyDataPepObj, dataPepObj] = getObjSection('dataPepObj')

// RELACIÓN CON FUNDACIONES, CORPORACIONES, INSTITUCIONES DE BENEFICIENCIA Y/O SIN FINES DE LUCRO
const relacionFundacionesIS= {
  hasRecords: { key: "hasRecords", val: undefined, title: "", id: "relacionFundacionesHasFundaciones", required: true},
  records: { key: "records", val: [], id: "relacionFundacionesRecords"},
};
const [keyRelacionFundaciones, relacionFundaciones] = getObjSection('relacionFundaciones')

const dataRelFundObjIS = {
  tipoInstitucion:    { key: "tipoInstitucion",    title: t("forms.label.tipoInstitucion"),    id: "dataRelFundObjTipoInstitucion", required: true, type: 'select' },
  nombreInstitucion:  { key: "nombreInstitucion",  title: t("forms.label.nombreInstitucion"),  maxLength:100, id: "dataRelFundObjNombreInstitucion", required: true, type: 'input'},
  tipoDocEmp:         { key: "tipoDocEmp",         title: t("forms.label.tipoDoc"),         id: "dataRelFundObjTipoDocEmp",         required: true, type: 'select' },
  docEmp:             { key: "docEmp",             title: t("forms.label.docEmp"),             maxLength:50, id: "dataRelFundObjDocEmp", required: true, type: 'input' },
  parentesco:         { key: "parentesco",         title: t("forms.label.parentesco"),         id: "dataRelFundObjParentesco", required: true, type: 'select' },
  nombre:             { key: "nombre",             title: t("forms.label.nombre"),             maxLength:100, id: "dataRelFundObjNombre", required: true, type: 'input' },
  tipoDoc:            { key: "tipoDoc",            title: t("forms.label.tipoDoc"),            id: "dataRelFundObjTipoDoc", required: true, type: 'select' },
  doc:                { key: "doc",                title: t("forms.label.doc"),                maxLength:50, id: "dataRelFundObjDoc", required: true, type: 'input' },
  cargoOpt:              { key: "cargoOpt",              title: t("forms.label.cargo"),              id: "dataRelFundObjCargoOpt", required: true, type: 'select' },
  otroCargo:          { key: "otroCargo",          title: t("forms.label.otroCargo"),          maxLength:50, id: "dataRelFundObjOtroCargo", required: true, type: 'input' },
  area:               { key: "area",               title: t("forms.label.area"),               maxLength:70, id: "dataRelFundObjArea", required: true, type: 'input' },
};

const [keyDataRelFundObj, dataRelFundObj] = getObjSection('dataRelFundObj')

const clearFieldValue = (fields) => {
  const fieldsToClear = {}
  fields.map(f => { fieldsToClear[f] = { value: undefined }})
  setFields(fieldsToClear);
  if(handleOnChangeFields) {
    const fieldsToClear2 = {}
    fields.map(f => { fieldsToClear2[f] = undefined })
    handleOnChangeFields(fieldsToClear2);
  }
}

//PARTICIPACION EN LA PROPIEDAD DE LA EMPRESA --> PARENTESCO === MI PERSONA
useEffect(() => {
  if(dataPempObj) {
    let nombre = undefined
    let rut = undefined
    let tipoDoc = undefined
    if (dataPempObj.parentesco.val === "Mi Persona") {
      nombre = registerData.nombre
      rut = registerData.rut
      tipoDoc = registerData.tipoDoc === 'Rut' ? 'Chile-Rut' : 'Otros'
    }
    setFields({ [dataPempObj.nombre.id]: { value: nombre }, 
                [dataPempObj.tipoDoc.id]: { value: tipoDoc },
                [dataPempObj.doc.id]: { value: rut }
              })
    if(handleOnChangeFields) {
      handleOnChangeFields({ 
        [dataPempObj.nombre.id]:  nombre, 
        [dataPempObj.tipoDoc.id]: tipoDoc, 
        [dataPempObj.doc.id]: rut, 
      })
    }
  }
}, [dataPempObj?.parentesco?.val]);

//PARTICIPACION EN OTRAS SOCIEDADES --> Cargo y Tipo de Propiedad
useEffect(() => {
  if(dataPsocObj) {
    if(dataPsocObj?.cargoOpt?.val !== "Accionista" && dataPsocObj?.cargoOpt?.val !== "Propietario") {
      clearFieldValue([dataPsocObj.porcentajeParticipacion.id, dataPsocObj.tipoPropiedad.id])
    }
    clearFieldValue([dataPsocObj.otroCargo.id])
    
    if(dataPsocObj.tipoPropiedad.val !== "Indirecta" || (dataPsocObj?.cargoOpt?.val !== "Accionista" && dataPsocObj?.cargoOpt?.val !== "Propietario")) {
      clearFieldValue([dataPsocObj.nombreEmpIndirecta.id, 
                      dataPsocObj.tipoDocEmpIndirecta.id,
                      dataPsocObj.docEmpIndirecta.id
                    ])

    }
  }
}, [dataPsocObj?.cargoOpt?.val, dataPsocObj?.tipoPropiedad?.val]);

//INTERLOCKING EJECUTIVO RELEVANTE
useEffect(() => {
  if(interObj) {
    if(interObj.cargoInterlocking.val !== "Ejecutivo Relevante") {
      clearFieldValue([interObj.cargoEjecutivoRelevante.id])
    }
  }
}, [interObj?.cargoInterlocking?.val]);

//PARTICIPACION EN LA PROPIEDAD DE LA EMPRESA --> Cargo y Tipo de Propiedad
useEffect(() => {
  if(dataPempObj) {
    if(dataPempObj?.cargoOpt?.val !== "Accionista" && dataPempObj?.cargoOpt?.val !== "Propietario") {
      clearFieldValue([dataPempObj.porcentajeParticipacion.id, dataPempObj.tipoPropiedad.id])
    }
    clearFieldValue([dataPempObj.otroCargo.id])
    
    if(dataPempObj.tipoPropiedad.val !== "Indirecta" || (dataPempObj?.cargoOpt?.val !== "Accionista" && dataPempObj?.cargoOpt?.val !== "Propietario")) {
      clearFieldValue([dataPempObj.nombreEmpIndirecta.id, 
                      dataPempObj.tipoDocEmpIndirecta.id,
                      dataPempObj.docEmpIndirecta.id
      ])
    }
  }
}, [dataPempObj?.cargoOpt?.val, dataPempObj?.tipoPropiedad?.val]);

//RELACIÓN CON FUNDACIONES, CORPORACIONES, INSTITUCIONES DE BENEFICENCIA Y/O SIN FINES DE LUCRO --> Otro Cargo
  useEffect(() => {
    if(dataRelFundObj) {
      clearFieldValue([dataRelFundObj.otroCargo.id])
    }
  }, [dataRelFundObj?.cargoOpt?.val]);

//PARTICIPACION EN OTRAS SOCIEDADES --> PARENTESCO === MI PERSONA
useEffect(() => {
  if(dataPsocObj) {
    let nombre = undefined
    let rut = undefined
    let tipoDoc = undefined
    if (dataPsocObj.parentesco.val === "Mi Persona") {
      nombre = registerData.nombre
      rut = registerData.rut
      tipoDoc = registerData.tipoDoc === 'Rut' ? 'Chile-Rut' : 'Otros'
    }
    setFields({ [dataPsocObj.nombre.id]: { value: nombre },
                [dataPsocObj.tipoDoc.id]: { value: tipoDoc },
                [dataPsocObj.doc.id]: { value: rut }
              })

    if(handleOnChangeFields) {
      handleOnChangeFields({ [dataPsocObj.nombre.id]:  nombre, 
        [dataPsocObj.tipoDoc.id]: tipoDoc, 
        [dataPsocObj.doc.id]: rut
      })
    }
  }
}, [dataPsocObj?.parentesco?.val]);


//FUNCIONARIOS PUBLICOS --> PARENTESCO === MI PERSONA
useEffect(() => {
  if(dataPepObj) {
    let nombre = undefined
    let rut = undefined
    let tipoDoc = undefined
    if (dataPepObj.parentesco.val === "Mi Persona") {
      nombre = registerData.nombre
      rut = registerData.rut
      tipoDoc = registerData.tipoDoc === 'Rut' ? 'Chile-Rut' : 'Otros'
    }
    setFields({ [dataPepObj.nombre.id]: { value: nombre },
                [dataPepObj.tipoDoc.id]: { value: tipoDoc },
                [dataPepObj.doc.id]: { value: rut }
              })

    if(handleOnChangeFields) {
      handleOnChangeFields({ 
        [dataPepObj.nombre.id]:  nombre, 
        [dataPepObj.tipoDoc.id]: tipoDoc, 
        [dataPepObj.doc.id]: rut,
      })
    }
  }
}, [dataPepObj?.parentesco?.val]);

//RELACIÓN CON FUNDACIONES, CORPORACIONES, INSTITUCIONES DE BENEFICIENCIA Y/O SIN FINES DE LUCRO --> PARENTESCO === MI PERSONA
useEffect(() => {
  if(dataRelFundObj) {
    let nombre = undefined
    let rut = undefined
    let tipoDoc = undefined
    if (dataRelFundObj.parentesco.val === "Mi Persona") {
      nombre = registerData.nombre
      rut = registerData.rut
      tipoDoc = registerData.tipoDoc === 'Rut' ? 'Chile-Rut' : 'Otros'
    }
    setFields({ [dataRelFundObj.nombre.id]: { value: nombre },
                [dataRelFundObj.tipoDoc.id]: { value: tipoDoc },
                [dataRelFundObj.doc.id]: { value: rut }
              })

    if(handleOnChangeFields) {
      handleOnChangeFields({ 
        [dataRelFundObj.nombre.id]:  nombre, 
        [dataRelFundObj.tipoDoc.id]: tipoDoc, 
        [dataRelFundObj.doc.id]: rut,
      })
    }
  }
}, [dataRelFundObj?.parentesco?.val]);

  useEffect(() => {
    const obj = { basicInformation: basicInformationIS,
          mallaParental: mallaParentalIS,
          mallaParObj: mallaParObjIS,
          participacionSociedades: participacionSociedadesIS,
          dataPsocObj: dataPsocObjIS,
          participacionEmpresa: participacionEmpresaIS,
          dataPempObj: dataPempObjIS,
          interlocking: interlockingIS,
          interObj: interObjIS,
          fueraDeHorario: fueraDeHorarioIS,
          actFueraObj: actFueraObjIS,
          empleosAnteriores: empleosAnterioresIS,
          empleosAntObj: empleosAntObjIS,
          relacionCompetencia: relacionCompetenciaIS,
          dataCompObj: dataCompObjIS,
          funcionariosPublicos: funcionariosPublicosIS,
          dataPepObj: dataPepObjIS,
          relacionFundaciones: relacionFundacionesIS,
          dataRelFundObj: dataRelFundObjIS,
    }

    if (match.params.view === "pdf") {
      setColLogo(5);
      setFormat("pdf");
    }

    getCountriesCodePromise().then((response) => {
      setPaises(response)
    })
    getFormPromise(match.params.id).then((response) => {
      if (response?.data?.status) {
        setApiForm(response.data);
        initVariablesFromObject(response.data, obj)
        setUser(response.data.recipient.request.createUser);
        setClientName(response.data.recipient.request.createUser.cliente.name);
        setRegisterData(response.data.recipient.record)
        if(response.data.recipient.request.createUser.cliente.outsourcer){
          setEmpresasGrupo(response.data.recipient.request.createUser.cliente.clientes.map(item => {
            return item.name
          }))
        }

        // getParamsPromise(
        //   response.data.recipient.request.createUser.cliente.id
        // ).then((response) => {
        //   setParams(response.data);
        //   setEmpresasGrupo(response.data.empresas)
        // });

        if(response.data.status === "SENT") {
          setDate(moment(response.data.receiveDate).format("DD-MM-YYYY"));
        }else {
          setDate(moment().format("DD-MM-YYYY"));
        }
      }
      setIsloading(false);
    });

    const handleMessage = (message) => {
      if(message.data && typeof message.data === 'string' && message.data.startsWith('DOCUSIGN') && apiConfig.url.startsWith(message.origin)) {
        const data = message.data.split('|')
        if(data.length === 4) {
          if(data[1] === "signing_complete") {
            const reqId = data[2] + "|" + data[3]
            sendDocument(reqId, apiFormRef.current)
          }else {
            closeHandlerSigner();
            notification["warning"]({
              message: "Firma cancelada",
            });
          }
        }
      }
    }

    window.addEventListener("message", handleMessage);
    return function () {
      window.removeEventListener("message", handleMessage);
    };
  }, [i18n.language]);

  const closeHandlerSigner = () => {
    setSignData(null)
    setOpenSigner(false)
  }



  const mallaColumns = [
    {
      title: t("forms.label.parentesco"),
      dataIndex: "parentesco",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.nombre"),
      dataIndex: "nombre",
    },
    {
      title: t("forms.label.tipoDoc"),
      dataIndex: "tipoDoc",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.doc"),
      dataIndex: "doc",
    },
    format === "html" && !signed
      ? {
          title: t("forms.label.accion"),
          dataIndex: "",
          width: "8%",
          render: (text, record, index) => (
            <a onClick={handleDeleteAttrTable({ attrTable: 'mallaParental', index })}>
              <Icon type="delete" />
            </a>
          ),
        }
      : {},
  ];
  
  const pempColumns = [
    {
      title: t("forms.label.parentesco"),
      dataIndex: "parentesco",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.nombre"),
      dataIndex: "nombre",
      className: "overflow-wrap-text",
    },
    {
      title: t("forms.label.tipoDoc"),
      dataIndex: "tipoDoc",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.doc"),
      dataIndex: "doc",
    },
    empresasGrupo.length > 0 && {
      title: t("forms.label.grupo"),
      dataIndex: "grupo",
    },
    {
      title: t("forms.label.cargo"),
      dataIndex: "cargoOpt",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    format === "html" && !signed
      ? {
          title: t("forms.label.accion"),
          dataIndex: "",
          width: "8%",
          render: (text, record, index) => (
            <a onClick={handleDeleteAttrTable({ attrTable: 'participacionEmpresa', index })}>
              <Icon type="delete" />
            </a>
          ),
        }
      : {},
  ].filter(Boolean);
  
  const psocColumns = [
    {
      title: t("forms.label.razonSocial"),
      dataIndex: "razonSocial",
      className: "overflow-wrap-text",
    },
    {
      title: t("forms.label.tipoDoc"),
      dataIndex: "tipoDocEmp",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      },
      width: '10%',
    },
    {
      title: t("forms.label.docEmp"),
      dataIndex: "docEmp",
    },
    {
      title: t("forms.label.paisEmp"),
      dataIndex: "paisEmp",
    },
    {
      title: t("forms.label.parentesco"),
      dataIndex: "parentesco",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.nombre"),
      dataIndex: "nombre",
    },
    {
      title: t("forms.label.tipoDoc"),
      dataIndex: "tipoDoc",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.doc"),
      dataIndex: "doc",
    },
    {
      title: t("forms.label.cargo"),
      dataIndex: "cargoOpt",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    format === "html" && !signed
      ? {
          title: t("forms.label.accion"),
          dataIndex: "",
          width: "8%",
          render: (text, record, index) => (
            <a onClick={handleDeleteAttrTable({ attrTable: 'participacionSociedades', index })}>
              <Icon type="delete" />
            </a>
          ),
        }
      : {},
  ].filter(Boolean);
  
  const interlockingColumns = [
    {
      title: t("forms.label.razonSocial"),
      dataIndex: "razonSocial",
      className: "overflow-wrap-text",
    },
    {
      title: t("forms.label.tipoDoc"),
      dataIndex: "tipoDoc",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.doc"),
      dataIndex: "doc",
    },
    {
      title: t("forms.label.fechaIngreso"),
      dataIndex: "fechaIngreso",
    },
    {
      title: t("forms.label.fechaTermino"),
      dataIndex: "fechaTermino",
    },
    {
      title: t("forms.label.cargo"),
      dataIndex: "cargoInterlocking",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    format === "html" && !signed
      ? {
          title: t("forms.label.accion"),
          dataIndex: "",
          width: "8%",
          render: (text, record, index) => (
            <a onClick={handleDeleteAttrTable({ attrTable: 'interlocking', index })}>
              <Icon type="delete" />
            </a>
          ),
        }
      : {},
  ];
  
  const fueraDeHorarioColumns = [
    {
      title: t("forms.label.razonSocial"),
      dataIndex: "razonSocial",
      className: "overflow-wrap-text",
    },
    {
      title: t("forms.label.tipoDoc"),
      dataIndex: "tipoDocEmp",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.docEmp"),
      dataIndex: "docEmp",
    },
    {
      title: t("forms.label.actividad"),
      dataIndex: "actividad",
      className: "overflow-wrap-text",
    },
    format === "html" && !signed
      ? {
          title: t("forms.label.accion"),
          dataIndex: "",
          width: "8%",
          render: (text, record, index) => (
            <a onClick={handleDeleteAttrTable({ attrTable: 'fueraDeHorario', index })}>
              <Icon type="delete" />
            </a>
          ),
        }
      : {},
  ];
  
  const empleosAnterioresColumns = [
    {
      title: t("forms.label.razonSocial"),
      dataIndex: "razonSocial",
      className: "overflow-wrap-text",
    },
    {
      title: t("forms.label.tipoDoc"),
      dataIndex: "tipoDocEmp",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.docEmp"),
      dataIndex: "docEmp",
    },
    {
      title: t("forms.label.cargoEjecutivoRelevante"),
      dataIndex: "cargo",
    },
    {
      title: t("forms.label.fechaIngreso"),
      dataIndex: "fechaIngreso",
    },
    {
      title: t("forms.label.fechaTermino"),
      dataIndex: "fechaTermino",
    },
    format === "html" && !signed
      ? {
          title: t("forms.label.accion"),
          dataIndex: "",
          width: "8%",
          render: (text, record, index) => (
            <a onClick={handleDeleteAttrTable({ attrTable: 'empleosAnteriores', index })}>
              <Icon type="delete" />
            </a>
          ),
        }
      : {},
  ];
  
  const relacionCompetenciaColumns = [
    {
      title: t("forms.label.razonSocial"),
      dataIndex: "razonSocial",
      className: "overflow-wrap-text",
    },
    {
      title: t("forms.label.tipoDoc"),
      dataIndex: "tipoDocEmp",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.docEmp"),
      dataIndex: "docEmp",
    },
    {
      title: t("forms.label.parentesco"),
      dataIndex: "parentesco",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.nombre"),
      dataIndex: "nombre",
    },
    {
      title: t("forms.label.tipoDoc"),
      dataIndex: "tipoDoc",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.doc"),
      dataIndex: "doc",
    },
    {
      title: t("forms.label.cargo"),
      dataIndex: "cargo",
    },
    format === "html" && !signed
      ? {
          title: t("forms.label.accion"),
          dataIndex: "",
          width: "8%",
          render: (text, record, index) => (
            <a onClick={handleDeleteAttrTable({ attrTable: 'relacionCompetencia', index })}>
              <Icon type="delete" />
            </a>
          ),
        }
      : {},
  ];
  
  const funcionariosPublicosColumns = [
    {
      title: t("forms.label.categoria"),
      dataIndex: "categoria",
    },
    {
      title: t("forms.label.nombreInstitucion"),
      dataIndex: "razonSocial",
    },
    {
      title: t("forms.label.parentesco"),
      dataIndex: "parentesco",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.nombre"),
      dataIndex: "nombre",
      className: "overflow-wrap-text",
    },
    {
      title: t("forms.label.tipoDoc"),
      dataIndex: "tipoDoc",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.doc"),
      dataIndex: "doc",
    },
    {
      title: t("forms.label.cargo"),
      dataIndex: "cargo",
    },
    {
      title: t("forms.label.fechaTermino"),
      dataIndex: "fechaTermino",
    },
    format === "html" && !signed
      ? {
          title: t("forms.label.accion"),
          dataIndex: "",
          width: "8%",
          render: (text, record, index) => (
            <a onClick={handleDeleteAttrTable({ attrTable: 'funcionariosPublicos', index })}>
              <Icon type="delete" />
            </a>
          ),
        }
      : {},
  ];
  
  const relacionFundacionesColumns = [
    {
      title: t("forms.label.tipoInstitucion"),
      dataIndex: "tipoInstitucion",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.nombreInstitucion"),
      dataIndex: "nombreInstitucion",
      className: "overflow-wrap-text",
    },
    {
      title: t("forms.label.tipoDoc"),
      dataIndex: "tipoDocEmp",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.docEmp"),
      dataIndex: "docEmp",
    },
    {
      title: t("forms.label.parentesco"),
      dataIndex: "parentesco",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.nombre"),
      dataIndex: "nombre",
    },
    {
      title: t("forms.label.tipoDoc"),
      dataIndex: "tipoDoc",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.doc"),
      dataIndex: "doc",
    },
    {
      title: t("forms.label.cargo"),
      dataIndex: "cargoOpt",
      render: (text) => {
        let camelText= toCamelCase(text);
        return t('forms.options.'+camelText, {ns: 'forms'})
      }
    },
    {
      title: t("forms.label.area"),
      dataIndex: "area",
      className: "overflow-wrap-text",
    },
    format === "html" && !signed
      ? {
          title: t("forms.label.accion"),
          dataIndex: "",
          width: "8%",
          render: (text, record, index) => (
            <a onClick={handleDeleteAttrTable({ attrTable: 'relacionFundaciones', index })}>
              <Icon type="delete" />
            </a>
          ),
        }
      : {},
  ];

  function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some((field) => fieldsError[field]);
  }
  

const handleOnAddAttrTableLocal = (attrObj, attrTable, attrRecords='records') => {
  setIsValidate(true);
  if(handleOnAddAttrTable(attrObj, attrTable, attrRecords)) {
    registersStop[attrObj] = false;
  }
}

  const handleSubmit = async (e) => {
    console.log(basicInformation)
    //VALIDACIONES
    e.preventDefault();
    setIsValidate(true);
    setValidarRegistros(true);
    validateFieldsAndScroll([basicInformation.cargo.id, basicInformation.gerencia.id, basicInformation.fechaContratacion.id])
    validateFieldsAndScroll([
      participacionEmpresa.hasRecords.id,
      participacionSociedades.hasRecords.id,
      relacionFundaciones.hasRecords.id,
      funcionariosPublicos.hasRecords.id,
      relacionCompetencia.hasRecords.id,
      fueraDeHorario.hasRecords.id,
      empleosAnteriores.hasRecords.id,
      interlocking.hasRecords.id,
    ]);
    if(mallaParental.records.val.length < 2){
      validateFieldsAndScroll(Object.values(mallaParObj).map(v => v.id))
      registersStop = { ...registersStop, [mallaParental.records.id]: true };
    }

    // Validación para Participación en Empresas
    if (participacionEmpresa.hasRecords.val && participacionEmpresa.records.val.length === 0) {
      validateFieldsAndScroll(Object.values(dataPempObj).map(v => v.id));
      registersStop = { ...registersStop, [participacionEmpresa.records.id]: true };
    }

    // Validación para Participación en Sociedades
    if (participacionSociedades.hasRecords.val && participacionSociedades.records.val.length === 0) {
      validateFieldsAndScroll(Object.values(dataPsocObj).map(v => v.id));
      registersStop = { ...registersStop, [participacionSociedades.records.id]: true };
    }

    // Validación para la nueva sección Relación con Fundaciones
    if (relacionFundaciones.hasRecords.val && relacionFundaciones.records.val.length === 0) {
      validateFieldsAndScroll(Object.values(dataRelFundObj).map(v => v.id));
      registersStop = { ...registersStop, [relacionFundaciones.records.id]: true };
    }

    // Validación para la nueva sección Funcionarios Públicos
    if (funcionariosPublicos.hasRecords.val && funcionariosPublicos.records.val.length === 0) {
      validateFieldsAndScroll(Object.values(dataPepObj).map(v => v.id));
      registersStop = { ...registersStop, [funcionariosPublicos.records.id]: true };
    }

    // Validación para la nueva sección Relación con la Competencia
    if (relacionCompetencia.hasRecords.val && relacionCompetencia.records.val.length === 0) {
      validateFieldsAndScroll(Object.values(dataCompObj).map(v => v.id));
      registersStop = { ...registersStop, [relacionCompetencia.records.id]: true };
    }

    // Validación para la nueva sección Actividades Fuera de Horario
    if (fueraDeHorario.hasRecords.val && fueraDeHorario.records.val.length === 0) {
      validateFieldsAndScroll(Object.values(actFueraObj).map(v => v.id));
      registersStop = { ...registersStop, [fueraDeHorario.records.id]: true };
    }

    // Validación para la nueva sección Empleos Anteriores
    if (empleosAnteriores.hasRecords.val && empleosAnteriores.records.val.length === 0) {
      validateFieldsAndScroll(Object.values(empleosAntObj).map(v => v.id));
      registersStop = { ...registersStop, [empleosAnteriores.records.id]: true };
    }

    //Validación para la sección Interlocking
    if (interlocking.hasRecords.val && interlocking.records.val.length === 0) {
      validateFieldsAndScroll(Object.values(interObj).map(v => v.id));
      registersStop = { ...registersStop, [interlocking.records.id]: true };
    }

    if (
      hasErrors(getFieldsError()) ||
      Object.values(registersStop).find((value) => value === true) !== undefined
    ) {
      notification["warning"]({
        message: t("messages.aml.missingRequiredField", { ns: "translations" }),
      });
    } else {
      //FUNCION DE PROMISE Y GESTION DE RESPONSE
      sendDocument()
    }
  };

  return (
    <FormLayout view={match.params.view} >
      <div style={{ position: "relative" }}>
        {isLoading ? (
          <div className="form-header">
            <Row>
              <Col xs={9}></Col>
              <Col xs={6}>
                <div className="form-wrapper" style={{ textAlign: "center" }}>
                  <Spin style={{ fontColor: "#fff" }} size={"large"} />
                </div>
              </Col>
              <Col xs={9}></Col>
            </Row>
          </div>
        ) : (
          <div className="form-trab-aguasandinas">
            {apiForm !== null ? (
              <div
                className={
                  "form-content " + format + " " +(!isValidate ? " form-validate-messages" : "")
                }
              >
                <Form onSubmit={handleSubmit} className="form-form">
                  <Row
                    className="title-logo"
                    gutter={[0, 6]}
                    style={{
                      backgroundColor: "rgba(255,255,255,0.9)",
                      marginTop: "0px",
                      marginBottom: "0px",
                      textAlign: "left",
                      paddingTop: "10px",
                      paddingLeft: "10px",
                    }}
                  >
                    <Col
                      xs={24 - colLogo}
                      sm={24 - colLogo}
                      md={24 - colLogo}
                      lg={24 - colLogo}
                      xl={24 - colLogo}
                    >
                      <h3>{t("forms.dir.title")}</h3>
                    </Col>
                    <Col
                      className="logo-col"
                      xs={colLogo}
                      sm={colLogo}
                      md={colLogo}
                      lg={colLogo}
                      xl={colLogo}
                    >
                      <Logo currentUser={{ userId: user.id, subclienteId: empresasGrupo && registerData?.subcliente ? registerData?.subcliente?.id : '0' }} isForm={true} />
                    </Col>
                  </Row>
                  <Row
                    className="date"
                    gutter={[0, 6]}
                    style={{
                      backgroundColor: "rgba(255,255,255,0.9)",
                      marginTop: "0px",
                      marginBottom: "0px",
                      textAlign: "left",
                      paddingBottom: "15px",
                      paddingLeft: "10px",
                    }}
                  >
                    <Col span={2} style={{ textAlign: "left" }}>
                      {t("forms.label.fecha")}:
                    </Col>
                    <Col span={4}>
                      <div
                        className="formDate"
                        style={{
                          marginLeft: "5px",
                          borderStyle: "solid",
                          borderWidth: "1px",
                          borderColor: "#e8e8e8",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {date}
                      </div>
                    </Col>
                    <Col span={13} style={{ textAlign: "right" }}>
                      {t("forms.label.folio")}:
                    </Col>
                    <Col span={5}>
                      <div
                        className="formDate"
                        style={{
                          borderStyle: "solid",
                          borderWidth: "1px",
                          borderColor: "#e8e8e8",
                          display: "flex",
                          justifyContent: "center",
                          marginRight: "10px",
                          marginLeft: "8px",
                        }}
                      >
                        {apiForm.folio !== null ? apiForm.folio : ""}
                      </div>
                    </Col>
                  </Row>
                  {apiForm.status === "SENT" &&
                  (format === "html") ? (
                    <>
                      <br />
                      <h3 style={{ textAlign: "center" }}>
                        {t("forms.messages.formWasSent1", {name: apiForm.recipient.record.name, ns: "forms"})}
                        <br />
                        {t("forms.messages.formWasSent2", {ns: "forms"})}:<br/><br/>
                        {apiForm.recipient.record.email}
                      </h3>
                    </>
                  ) : (
                    <div style={{marginBottom: 20}}>
                      <Row className="summary">
                        <Col span={24}>
                          <p>
                            {t("forms.sonda.dir.intro", {ns: "formsSonda"})}
                          </p>
                        </Col>
                      </Row>
                      <Row
                        className="lineamiento subheader"
                        style={{ marginTop: "0px" }}
                      >
                        <Col xl={24}>{t("forms.intro")}</Col>
                      </Row>
                      <Row className="summary">
                        <Col xl={24}>
                          <p>
                            {t("forms.sonda.dir.intro.text1", {name: apiForm.recipient.record.nombre, rut:apiForm.recipient.record.rut, clientName, ns: "formsSonda"})} {" "}
                          </p>
                          <p>
                            {t("forms.sonda.dir.intro.text2", {clientName, ns: 'formsSonda'})}
                          </p>
                          <p>
                            {t("forms.sonda.dir.intro.text3", {ns: 'formsSonda'})}
                          </p>
                          <p>{t("forms.sonda.dir.intro.text4", {ns: 'formsSonda'})}</p>
                        </Col>
                      </Row>
                      <Row
                        className="lineamiento subheader"
                        style={{ marginTop: "0px" }}
                      >
                        <Col xl={24}>{t("forms.titles.mallaParental")}</Col>
                      </Row>
                      <Row className="summary">
                        <p>
                          {t("forms.sonda.dir.mallaParental.text1", {ns:'formsSonda'})}
                        </p>
                        {format === 'html' &&
                          <p>
                            {t("forms.sonda.dir.mallaParental.text2", {ns:'formsSonda'})}
                          </p>
                        }
                      </Row>
                      {format === 'html' &&
                        <Row gutter={[20]}>
                          {renderFormItemTable({
                            section: mallaParObj.parentesco,
                            options: optList.parentesco.slice(1),
                          })}
                          {renderFormItemTable({
                            section: mallaParObj.nombre,
                          })}
                          {renderFormItemTable({
                            section: mallaParObj.tipoDoc,
                          })}
                          {renderFormItemTable({
                            section: mallaParObj.doc,
                            validator: docValidator(mallaParObj.tipoDoc.val, "persona")
                          })}
                      </Row>
                      }
                      {mallaParental.records.val.length < 2 &&
                        validarRegistros && (
                          <Col
                          span={24}
                          style= {{color: 'red'}}
                          className="missing-registers ant-form-explain"
                          >
                            {t("messages.aml.registersRequired", {ns: 'translations'})}
                          </Col>
                      )}
                      {format === 'html' &&
                        <Row>
                          <Col className={mallaParental.records.val.length < 1 && "addRelation"} xl={3}>
                            <Button type="primary" htmlType="button" onClick={()=> handleOnAddAttrTableLocal('mallaParObj', 'mallaParental')} icon="plus" > {t("forms.añadir")} </Button>
                          </Col>
                          <Col className={mallaParental.records.val.length < 1 && "addRelation"} xl={3}>
                            <Button type="primary" htmlType="button" icon="delete" onClick={(e)=>handleOnClear('mallaParObj')}> {t("forms.limpiar")} </Button>
                          </Col>
                        </Row>
                      }
                      {mallaParental.records.val.length > 0 && format === "html" ?
                        <Table columns={mallaColumns} dataSource={mallaParental.records.val} size="middle" pagination={false} ></Table>
                        :
                        toDescriptionsPdf( mallaParental.records.val, mallaParObj, apiForm.typeSol )
                      }

                      <Row className="lineamiento subheader">
                        <Col xl={24}>{t("forms.titles.pemp")}</Col>
                      </Row>
                      <Row className="summary">
                        <Col span={21}>
                          {t("forms.sonda.dir.pemp.text1", {clientName, ns: 'formsSonda'})}
                        </Col>
                        {renderFormItem({
                          label: "",
                          colClassName: "switch-col",
                          itemClassName: "radio-item",
                          name: participacionEmpresa.hasRecords.id,
                          labelCol: 0,
                          wrapperCol: 0,
                          offset: 0,
                          initialValue: participacionEmpresa.hasRecords.val,
                          rules: [
                            {
                              required: true,
                              message: t("messages.aml.dontForgetSelect", {ns: 'translations'}),
                            },
                          ],
                          wrapperCols: 3,
                          item: (
                            <Radio.Group
                              readOnly={format==='pdf'}
                              onChange={({ target }) =>{
                                handlerOnChangeObjAttr(
                                  participacionEmpresa.hasRecords.id,
                                  target.value
                                )
                              }
                              }
                            >
                              <Radio style={radioStyle} value={true}>
                                {t("forms.options.si")}
                              </Radio>
                              <Radio style={radioStyle} value={false}>
                                {t("forms.options.no")}
                              </Radio>
                            </Radio.Group>
                          ),
                        })}
                      </Row>
                      {participacionEmpresa.hasRecords.val && (
                        <>
                        {format === 'html' &&
                          <Row>
                            <Divider orientation='left'>
                              {t("forms.subtitles.personaRelacionCon", {clientName})}
                            </Divider>
                            <Row gutter={[20]}>
                              {renderFormItemTable({
                                section: dataPempObj.parentesco,
                              })}
                              {renderFormItemTable({
                                section: dataPempObj.nombre,
                              })}
                              {renderFormItemTable({
                                section: dataPempObj.tipoDoc,
                              })}
                              {renderFormItemTable({
                                section: dataPempObj.doc,
                                validator: docValidator(dataPempObj.tipoDoc.val, "persona")
                              })}
                            </Row>
                            <Row gutter={[20]}>
                              {empresasGrupo?.length > 0 && renderFormItemTable({
                                section: dataPempObj.grupo,
                                options: empresasGrupo?.map(empresa => ({ val: empresa, text: empresa }))
                              })}
                            </Row>

                            <Divider orientation='left'>
                              {t("forms.subtitles.cargoOcupadoPor", {var: dataPempObj.nombre.val})}
                            </Divider>
                            <Row className="inner-row" gutter={[16, 8]}>
                              {renderFormItemTable({
                                section: dataPempObj.cargoOpt,
                              })}

                              {(dataPempObj.cargoOpt.val === "Otro" || dataPempObj.cargoOpt.val === "Gerente" || dataPempObj.cargoOpt.val === "Ejecutivo Principal") && renderFormItemTable({
                                section: dataPempObj.otroCargo,
                              })}

                              {(dataPempObj.cargoOpt.val === "Socio") &&
                                renderFormItemTable({
                                section: dataPempObj.porcentajeParticipacion,
                              })}

                              {(dataPempObj.cargoOpt.val === "Accionista" || dataPempObj.cargoOpt.val === "Propietario") &&
                                renderFormItemTable({
                                  section: dataPempObj.tipoPropiedad,
                                })
                              }
                              {(dataPempObj.cargoOpt.val === "Accionista" || dataPempObj.cargoOpt.val === "Propietario") &&
                                renderFormItemTable({
                                  section: dataPempObj.porcentajeParticipacion, // Campo para Porcentaje de Propiedad
                                })
                              }
                              {(dataPempObj.cargoOpt.val === "Accionista" || dataPempObj.cargoOpt.val === "Propietario") && dataPempObj.tipoPropiedad.val === "Indirecta" &&
                                renderFormItemTable({
                                  section: dataPempObj.nombreEmpIndirecta, // Campo para Nombre de Empresa Indirecta
                                })
                              }
                            </Row>

                            <Row className="inner-row" gutter={[16, 8]}>
                              {(dataPempObj.cargoOpt.val === "Accionista" || dataPempObj.cargoOpt.val === "Propietario") && dataPempObj.tipoPropiedad.val === "Indirecta" &&
                                renderFormItemTable({
                                  section: dataPempObj.tipoDocEmpIndirecta, // Campo para Tipo de Documento de Empresa Indirecta
                                  cols: 8,
                                  options: optList.tipoDoc,
                                })
                              }
                              {(dataPempObj.cargoOpt.val === "Accionista" || dataPempObj.cargoOpt.val === "Propietario") && dataPempObj.tipoPropiedad.val === "Indirecta" &&
                                renderFormItemTable({
                                  section: dataPempObj.docEmpIndirecta, // Campo para Rut de Empresa Indirecta
                                  validator: docValidator(dataPempObj.tipoDocEmpIndirecta.val, "empresa") // Validador para Rut
                                })
                              }
                            </Row>

                          </Row>
                        }
                        {participacionEmpresa.records.val.length < 1 &&
                          validarRegistros && (
                            <Col
                              span={24}
                              style= {{color: 'red'}}
                              className="missing-registers ant-form-explain"
                            >
                            {t("messages.aml.registersRequired", {ns: 'translations'})}
                            </Col>
                        )}
                        {format === 'html' &&
                          <Row>
                            <Col className={participacionEmpresa.records.val.length < 1 && "addRelation"} xl={3}>
                              <Button type="primary" htmlType="button" onClick={()=> handleOnAddAttrTableLocal('dataPempObj', 'participacionEmpresa')} icon="plus" > {t("forms.añadir")} </Button>
                            </Col>
                            <Col className={participacionEmpresa.records.val.length < 1 && "addRelation"} xl={3}>
                              <Button type="primary" htmlType="button" icon="delete" onClick={(e)=>handleOnClear('dataPempObj')}> {t("forms.limpiar")} </Button>
                            </Col>
                          </Row>
                        }
                        
                          {participacionEmpresa.records.val.length > 0 && format === "html" ? (
                            <Table columns={pempColumns} dataSource={participacionEmpresa.records.val} size="middle" pagination={false} ></Table>
                          ) : (
                            toDescriptionsPdf(participacionEmpresa.records.val, dataPempObj, apiForm.typeSol)
                          )}
                        </>
                      )}

                      <Row
                        className="lineamiento subheader"
                      >
                        <Col xl={24}>{t("forms.titles.psoc")}</Col>
                      </Row>
                      <Row className="summary">
                        <Col span={21}>
                          <div>
                            {t("forms.sonda.dir.psoc.text1", {ns: 'formsSonda'})}
                          </div>
                        </Col>
                        {renderFormItem({
                          label: "",
                          colClassName: "switch-col",
                          itemClassName: "radio-item",
                          name: participacionSociedades.hasRecords.id,
                          labelCol: 0,
                          wrapperCol: 0,
                          offset: 0,
                          initialValue: participacionSociedades.hasRecords.val,
                          rules: [
                            {
                              required: true,
                              message: t("messages.aml.dontForgetSelect", {ns: 'translations'}),
                            },
                          ],
                          wrapperCols: 3,
                          item: (
                            <Radio.Group
                              onChange={({ target }) =>
                                handlerOnChangeObjAttr(
                                  participacionSociedades.hasRecords.id,
                                  target.value
                                )
                              }
                            >
                              <Radio style={radioStyle} value={true}>
                                {t("forms.options.si")}
                              </Radio>
                              <Radio style={radioStyle} value={false}>
                                {t("forms.options.no")}
                              </Radio>
                            </Radio.Group>
                          ),
                        })
                        }
                      </Row>
                      {participacionSociedades.hasRecords.val && (
                      <>
                        {format === 'html' &&
                        <>
                          <Row gutter={[20]}>
                            <Divider orientation='left'>
                              {t("forms.subtitles.datosEmpresaPoseeParticipacion")}
                            </Divider>
                            {renderFormItemTable({
                              section: dataPsocObj.razonSocial,
                            })}
                            {renderFormItemTable({
                              section: dataPsocObj.tipoDocEmp,
                              options: optList.tipoDoc,
                            })}
                            {renderFormItemTable({
                              section: dataPsocObj.docEmp,
                              validator: docValidator(dataPsocObj.tipoDocEmp.val, "empresa")
                            })}
                            {renderFormItemTable({
                              section: dataPsocObj.paisEmp,
                              options: paises.map(item => {
                                return {val: item.country, text: item.country}
                              })
                            })}
                          </Row>
                        
                          <Row gutter={[20]}>
                            <Divider orientation='left'>
                              {t("forms.subtitles.personaRelacionada", {var: dataPsocObj.razonSocial.val})} 
                            </Divider>
                            {renderFormItemTable({
                              section: dataPsocObj.parentesco,
                            })}
                            {renderFormItemTable({
                              section: dataPsocObj.nombre,
                            })}
                            {renderFormItemTable({
                              section: dataPsocObj.tipoDoc,
                            })}
                            {renderFormItemTable({
                              section: dataPsocObj.doc,
                              validator: docValidator(dataPsocObj.tipoDoc.val, "persona")
                            })}
                          </Row>
                          <Row className="inner-row" gutter={[16, 8]}>
                            {renderFormItemTable({
                              section: dataPsocObj.cargoOpt,
                              options: optList.cargoOpt.map(option =>
                                option.val === "Gerente"
                                  ? { val: "Propietario", text: "Propietario" }
                                  : option
                              ),
                            })}

                            {(dataPsocObj.cargoOpt.val === "Otro" || dataPsocObj.cargoOpt.val === "Gerente" || dataPsocObj.cargoOpt.val === "Ejecutivo Principal") && renderFormItemTable({
                              section: dataPsocObj.otroCargo,
                            })}

                            {(dataPsocObj.cargoOpt.val === "Socio") &&
                              renderFormItemTable({
                              section: dataPsocObj.porcentajeParticipacion
                            })}

                            {(dataPsocObj.cargoOpt.val === "Accionista" || dataPsocObj.cargoOpt.val === "Propietario") &&
                              renderFormItemTable({
                                section: dataPsocObj.tipoPropiedad, // Campo para Tipo de Propiedad
                              })
                            }
                            {(dataPsocObj.cargoOpt.val === "Accionista" || dataPsocObj.cargoOpt.val === "Propietario") &&
                              renderFormItemTable({
                                section: dataPsocObj.porcentajeParticipacion, // Campo para Porcentaje de Propiedad
                              })
                            }
                            {(dataPsocObj.cargoOpt.val === "Accionista" || dataPsocObj.cargoOpt.val === "Propietario") && dataPsocObj.tipoPropiedad.val === "Indirecta" &&
                              renderFormItemTable({
                                section: dataPsocObj.nombreEmpIndirecta, // Campo para Nombre de Empresa Indirecta
                              })
                            }
                          </Row>

                          <Row className="inner-row" gutter={[16, 8]}>
                            {(dataPsocObj.cargoOpt.val === "Accionista" || dataPsocObj.cargoOpt.val === "Propietario") && dataPsocObj.tipoPropiedad.val === "Indirecta" &&
                              renderFormItemTable({
                                section: dataPsocObj.tipoDocEmpIndirecta, // Campo para Tipo de Documento de Empresa Indirecta
                                cols: 8,
                                options: optList.tipoDoc,
                              })
                            }
                            {(dataPsocObj.cargoOpt.val === "Accionista" || dataPsocObj.cargoOpt.val === "Propietario") && dataPsocObj.tipoPropiedad.val === "Indirecta" &&
                              renderFormItemTable({
                                section: dataPsocObj.docEmpIndirecta, // Campo para Rut de Empresa Indirecta
                                validator: docValidator(dataPsocObj.tipoDocEmpIndirecta.val, "empresa") // Validador para Rut
                              })
                            }
                          </Row>

                      
                          {participacionSociedades.records.val.length < 1 &&
                            validarRegistros && (
                              <Col
                              span={24}
                              style= {{color: 'red'}}
                              className="missing-registers ant-form-explain"
                              >
                              {t("messages.aml.registersRequired", {ns: 'translations'})}
                              </Col>
                          )}
                          <Row>
                            <Col className={participacionSociedades.records.val.length < 1 && "addRelation"} xl={3}>
                              <Button type="primary" htmlType="button" onClick={()=> handleOnAddAttrTableLocal('dataPsocObj', 'participacionSociedades')} icon="plus" > {t("forms.añadir")} </Button>
                            </Col>
                            <Col className={participacionSociedades.records.val.length < 1 && "addRelation"} xl={3}>
                              <Button type="primary" htmlType="button" icon="delete" onClick={(e)=>handleOnClear('dataPsocObj')}> {t("forms.limpiar")} </Button>
                            </Col>
                          </Row>
                        </>
                        }
                        {participacionSociedades.records.val.length > 0 && format === "html" ?
                          <Table columns={psocColumns} dataSource={participacionSociedades.records.val} size="middle" pagination={false} ></Table>
                          :
                          toDescriptionsPdf( participacionSociedades.records.val, dataPsocObj, apiForm.typeSol )
                        }
                      </>
                      )}

                      <Row className="lineamiento subheader">
                        <Col xl={24}>INTERLOCKING</Col>
                      </Row>
                      <Row className="summary">
                        <Col span={21}>
                          <p>
                            {t("forms.sonda.dir.interlocking.text1", {ns:'formsSonda'})}
                          </p>
                          <p>
                            {t("forms.sonda.dir.interlocking.text2", {clientName, ns:'formsSonda'})}
                          </p>
                        </Col>
                        {renderFormItem({
                          label: "",
                          colClassName: "switch-col",
                          itemClassName: "radio-item",
                          name: interlocking.hasRecords.id,
                          labelCol: 0,
                          wrapperCol: 0,
                          offset: 0,
                          initialValue: interlocking.hasRecords.val,
                          rules: [
                            {
                              required: true,
                              message: t("messages.aml.dontForgetSelect", {ns: 'translations'}),
                            },
                          ],
                          wrapperCols: 3,
                          item: (
                            <Radio.Group
                              onChange={({ target }) =>
                                handlerOnChangeObjAttr(interlocking.hasRecords.id, target.value)
                              }
                            >
                              <Radio style={radioStyle} value={true}>
                                {t("forms.options.si")}
                              </Radio>
                              <Radio style={radioStyle} value={false}>
                                {t("forms.options.no")}
                              </Radio>
                            </Radio.Group>
                          ),
                        })}
                      </Row>

                      {interlocking.hasRecords.val && (
                        <>
                        {format === 'html' &&
                          <Row>
                            <Row gutter={[20]}>
                              {renderFormItemTable({
                                section: interObj.razonSocial,
                              })}
                              {renderFormItemTable({
                                section: interObj.tipoDoc,
                              })}
                              {renderFormItemTable({
                                section: interObj.doc,
                                validator: docValidator(interObj.tipoDoc.val, 'empresa')
                              })}
                              {renderFormItemTable({
                                section: interObj.fechaIngreso,
                              })}
                            </Row>
                            <Row gutter={[20]}>
                              {renderFormItemTable({
                                section: interObj.fechaTermino,
                              })}
                              {renderFormItemTable({
                                section: interObj.cargoInterlocking,
                              })}
                              {interObj.cargoInterlocking.val === "Ejecutivo Relevante" && renderFormItemTable({
                                section: interObj.cargoEjecutivoRelevante,
                              })}

                            </Row>
                          </Row>
                        }
                        {interlocking.records.val.length < 1 &&
                            validarRegistros && (
                              <Col
                              span={24}
                              style= {{color: 'red'}}
                              className="missing-registers ant-form-explain"
                              >
                              {t("messages.aml.registersRequired", {ns: 'translations'})}
                              </Col>
                          )}
                          {format === 'html' &&
                            <Row>
                              <Col className="addRelation" xl={3}>
                                <Button type="primary" htmlType="button" onClick={()=> handleOnAddAttrTableLocal('interObj', 'interlocking')} icon="plus" > {t("forms.añadir")} </Button>
                              </Col>
                              <Col className="addRelation" xl={3}>
                                <Button type="primary" htmlType="button" icon="delete" onClick={(e)=>handleOnClear('interObj')}> {t("forms.limpiar")} </Button>
                              </Col>
                            </Row>
                          }
                          {interlocking.records.val.length > 0 && format === "html" ? (
                            <Table
                              columns={interlockingColumns} // Define las columnas para la tabla de interlocking
                              dataSource={interlocking.records.val}
                              size="middle"
                              pagination={false}
                            />
                          ) : (
                            toDescriptionsPdf(interlocking.records.val, interObj, apiForm.typeSol)
                          )}
                        </>
                      )}

                      <Row className="lineamiento subheader">
                        <Col xl={24}>{t("forms.titles.actividadFuera")}</Col>
                      </Row>
                      <Row className="summary">
                        <Col span={21}>
                          <div>
                            {t("forms.sonda.dir.actividadFuera.text1", {clientName, ns:'formsSonda'})}
                          </div>
                        </Col>
                        {renderFormItem({
                          label: "",
                          colClassName: "switch-col",
                          itemClassName: "radio-item",
                          name: fueraDeHorario.hasRecords.id,
                          labelCol: 0,
                          wrapperCol: 0,
                          offset: 0,
                          initialValue: fueraDeHorario.hasRecords.val,
                          rules: [
                            {
                              required: true,
                              message: t("messages.aml.dontForgetSelect", {ns: 'translations'}),
                            },
                          ],
                          wrapperCols: 3,
                          item: (
                            <Radio.Group
                              onChange={({ target }) =>
                                handlerOnChangeObjAttr(fueraDeHorario.hasRecords.id, target.value)
                              }
                            >
                              <Radio style={radioStyle} value={true}>
                                {t("forms.options.si")}
                              </Radio>
                              <Radio style={radioStyle} value={false}>
                                {t("forms.options.no")}
                              </Radio>
                            </Radio.Group>
                          ),
                        })}
                      </Row>

                      {fueraDeHorario.hasRecords.val && (
                        <>
                          {format === 'html' &&
                            <>
                              <Row gutter={[20]}>
                                {renderFormItemTable({
                                  section: actFueraObj.razonSocial,
                                })}

                                {renderFormItemTable({
                                  section: actFueraObj.tipoDocEmp,
                                  options: optList.tipoDoc,
                                })}

                                {renderFormItemTable({
                                  section: actFueraObj.docEmp,
                                  validator: docValidator(actFueraObj.tipoDocEmp.val, 'empresa')
                                })}

                                {renderFormItemTable({
                                  section: actFueraObj.actividad,
                                })}
                              </Row>
                              {fueraDeHorario.records.val.length < 1 &&
                                validarRegistros && (
                                  <Col
                                  span={24}
                                  style= {{color: 'red'}}
                                  className="missing-registers ant-form-explain"
                                  >
                                  {t("messages.aml.registersRequired", {ns: 'translations'})}
                                  </Col>
                              )}
                              <Row>
                                <Col className="addRelation" xl={3}>
                                  <Button
                                    type="primary"
                                    htmlType="button"
                                    onClick={() => handleOnAddAttrTableLocal('actFueraObj', 'fueraDeHorario')}
                                    icon="plus"
                                  >
                                    {t("forms.añadir")}
                                  </Button>
                                </Col>
                                <Col className="addRelation" xl={3}>
                                  <Button
                                    type="primary"
                                    htmlType="button"
                                    icon="delete"
                                    onClick={() => handleOnClear('actFueraObj')}
                                  >
                                    {t("forms.limpiar")}
                                  </Button>
                                </Col>
                              </Row>
                            </>
                          }

                          {fueraDeHorario.records.val.length > 0 && format === "html" ? (
                            <Table
                              columns={fueraDeHorarioColumns}
                              dataSource={fueraDeHorario.records.val}
                              size="middle"
                              pagination={false}
                            />
                          ) : (
                            toDescriptionsPdf(fueraDeHorario.records.val, actFueraObj, apiForm.typeSol)
                          )}
                        </>
                      )}

                      <Row className="lineamiento subheader">
                        <Col xl={24}>{t("forms.titles.relacionesLaboralesAnteriores")}</Col>
                      </Row>
                      <Row className="summary">
                        <Col span={21}>
                          <div>
                            {t("forms.sonda.dir.relacionesLaboralesAnteriores.text1", {clientName, ns:'formsSonda'})}
                          </div>
                        </Col>
                        {renderFormItem({
                          label: "",
                          colClassName: "switch-col",
                          itemClassName: "radio-item",
                          name: empleosAnteriores.hasRecords.id,
                          labelCol: 0,
                          wrapperCol: 0,
                          offset: 0,
                          initialValue: empleosAnteriores.hasRecords.val,
                          rules: [
                            {
                              required: true,
                              message: t("messages.aml.dontForgetSelect", {ns: 'translations'}),
                            },
                          ],
                          wrapperCols: 3,
                          item: (
                            <Radio.Group
                              onChange={({ target }) =>
                                handlerOnChangeObjAttr(empleosAnteriores.hasRecords.id, target.value)
                              }
                            >
                              <Radio style={radioStyle} value={true}>
                                {t("forms.options.si")}
                              </Radio>
                              <Radio style={radioStyle} value={false}>
                                {t("forms.options.no")}
                              </Radio>
                            </Radio.Group>
                          ),
                        })}
                      </Row>

                      {empleosAnteriores.hasRecords.val && (
                        <>
                        {format === 'html' &&
                          <>
                          <Row>
                            <Row gutter={[20]}>
                              {renderFormItemTable({
                                section: empleosAntObj.razonSocial,
                              })}

                              {renderFormItemTable({
                                section: empleosAntObj.tipoDocEmp,
                                options: optList.tipoDoc,
                              })}

                              {renderFormItemTable({
                                section: empleosAntObj.docEmp,
                                validator: docValidator(empleosAntObj.tipoDocEmp.val,"empresa")
                              })}

                              {renderFormItemTable({
                                section: empleosAntObj.cargo,
                              })}
                            </Row>
                            <Row gutter={[20]}>
                              {renderFormItemTable({
                                section: empleosAntObj.fechaIngreso,
                              })}

                              {renderFormItemTable({
                                section: empleosAntObj.fechaTermino,
                              })}
                            </Row>
                          </Row>
                            {empleosAnteriores.records.val.length < 1 &&
                              validarRegistros && (
                                <Col
                                  span={24}
                                  style= {{color: 'red'}}
                                  className="missing-registers ant-form-explain"
                                >
                                  {t("messages.aml.registersRequired", {ns: 'translations'})}
                                </Col>
                            )}
                            <Row>
                              <Col className="addRelation" xl={3}>
                                <Button
                                  type="primary"
                                  htmlType="button"
                                  onClick={() => handleOnAddAttrTableLocal('empleosAntObj', 'empleosAnteriores')}
                                  icon="plus"
                                >
                                  {t("forms.añadir")}
                                </Button>
                              </Col>
                              <Col className="addRelation" xl={3}>
                                <Button
                                  type="primary"
                                  htmlType="button"
                                  icon="delete"
                                  onClick={() => handleOnClear('empleosAntObj')}
                                >
                                  {t("forms.limpiar")}
                                </Button>
                              </Col>
                            </Row>
                          </>
                        }

                          {empleosAnteriores.records.val.length > 0 && format === "html" ? (
                            <Table
                              columns={empleosAnterioresColumns}
                              dataSource={empleosAnteriores.records.val}
                              size="middle"
                              pagination={false}
                            />
                          ) : (
                            toDescriptionsPdf(empleosAnteriores.records.val, empleosAntObj, apiForm.typeSol)
                          )}
                        </>
                      )}

                      {/* RELACION CON LA COMPETENCIA */}
                      <Row className="lineamiento subheader">
                        <Col xl={24}>{t("forms.titles.relacionCompetencia")}</Col>
                      </Row>
                      <Row className="summary">
                        <Col span={21}>
                          <div>
                            {t("forms.sonda.dir.relacionCompetencia.text1", {ns:'formsSonda'})}
                          </div>
                        </Col>
                        {renderFormItem({
                          label: "",
                          colClassName: "switch-col",
                          itemClassName: "radio-item",
                          name: relacionCompetencia.hasRecords.id,
                          labelCol: 0,
                          wrapperCol: 0,
                          offset: 0,
                          initialValue: relacionCompetencia.hasRecords.val,
                          rules: [
                            {
                              required: true,
                              message: t("messages.aml.dontForgetSelect", {ns: 'translations'}),
                            },
                          ],
                          wrapperCols: 3,
                          item: (
                            <Radio.Group
                              onChange={({ target }) =>
                                handlerOnChangeObjAttr(relacionCompetencia.hasRecords.id, target.value)
                              }
                            >
                              <Radio style={radioStyle} value={true}>
                                {t("forms.options.si")}
                              </Radio>
                              <Radio style={radioStyle} value={false}>
                                {t("forms.options.no")}
                              </Radio>
                            </Radio.Group>
                          ),
                        })}
                      </Row>

                      {relacionCompetencia.hasRecords.val && (
                        <>
                        {format === 'html' &&
                          <>
                            <Row>
                              <Divider orientation="left">
                                {t("forms.subtitles.empresaCompetidoraDe", {clientName})}
                              </Divider>
                              <Row gutter={[20]}>
                                {renderFormItemTable({
                                  section: dataCompObj.razonSocial,
                                })}

                                {renderFormItemTable({
                                  section: dataCompObj.tipoDocEmp,
                                  options: optList.tipoDoc,
                                })}

                                {renderFormItemTable({
                                  section: dataCompObj.docEmp,
                                  validator: docValidator(dataCompObj.tipoDocEmp.val, "empresa"),
                                })}
                              </Row>
                              <Divider orientation="left">
                                {t("forms.subtitles.personaRelacionada", {var: dataCompObj.razonSocial.val})}
                              </Divider>
                              <Row gutter={[20]}>
                                {renderFormItemTable({
                                  section: dataCompObj.parentesco,
                                  options: optList.parentesco.slice(1),
                                })}

                                {renderFormItemTable({
                                  section: dataCompObj.nombre,
                                })}

                                {renderFormItemTable({
                                  section: dataCompObj.tipoDoc,
                                })}

                                {renderFormItemTable({
                                  section: dataCompObj.doc,
                                  validator: docValidator(dataCompObj.tipoDoc.val, "persona")
                                })}
                              </Row>
                              <Row gutter={[20]}>
                                {renderFormItemTable({
                                  section: dataCompObj.cargo,
                                })}
                              </Row>
                            </Row>
                            {relacionCompetencia.records.val.length < 1 &&
                              validarRegistros && (
                                <Col
                                  span={24}
                                  style= {{color: 'red'}}
                                  className="missing-registers ant-form-explain"
                                >
                                  {t("messages.aml.registersRequired", {ns: 'translations'})}
                                </Col>
                            )}
                            <Row>
                              <Col className="addRelation" xl={3}>
                                <Button
                                  type="primary"
                                  htmlType="button"
                                  onClick={() => handleOnAddAttrTableLocal('dataCompObj', 'relacionCompetencia')}
                                  icon="plus"
                                >
                                  {t("forms.añadir")}
                                </Button>
                              </Col>
                              <Col className="addRelation" xl={3}>
                                <Button
                                  type="primary"
                                  htmlType="button"
                                  icon="delete"
                                  onClick={() => handleOnClear('dataCompObj')}
                                >
                                  {t("forms.limpiar")}
                                </Button>
                              </Col>
                            </Row>
                          </>
                        }

                          {relacionCompetencia.records.val.length > 0 && format === "html" ? (
                            <Table
                              columns={relacionCompetenciaColumns}
                              dataSource={relacionCompetencia.records.val}
                              size="middle"
                              pagination={false}
                            />
                          ) : (
                            toDescriptionsPdf(relacionCompetencia.records.val, dataCompObj, apiForm.typeSol)
                          )}
                        </>
                      )}


                      <Row className="lineamiento subheader">
                        <Col xl={24}>{t("forms.titles.infoPep")}</Col>
                      </Row>
                      <Row className="summary">
                        <Col span={21}>
                        <p>
                          {t("forms.sonda.dir.infoPep.text1", {ns:'formsSonda'})}
                        </p>
                        <p>
                          {t("forms.sonda.dir.infoPep.text2", {ns:'formsSonda'})}
                        </p>
                        </Col>
                        {renderFormItem({
                          label: "",
                          colClassName: "switch-col",
                          itemClassName: "radio-item",
                          name: funcionariosPublicos.hasRecords.id,
                          labelCol: 0,
                          wrapperCol: 0,
                          offset: 0,
                          initialValue: funcionariosPublicos.hasRecords.val,
                          rules: [
                            {
                              required: true,
                              message: t("messages.aml.dontForgetSelect", {ns: 'translations'}),
                            },
                          ],
                          wrapperCols: 3,
                          item: (
                            <Radio.Group
                              onChange={({ target }) =>
                                handlerOnChangeObjAttr(funcionariosPublicos.hasRecords.id, target.value)
                              }
                            >
                              <Radio style={radioStyle} value={true}>
                                {t("forms.options.si")}
                              </Radio>
                              <Radio style={radioStyle} value={false}>
                                {t("forms.options.no")}
                              </Radio>
                            </Radio.Group>
                          ),
                        })}
                      </Row>

                      {funcionariosPublicos.hasRecords.val && (
                        <>
                          {format === 'html' &&
                            <Row>
                              <Divider orientation='left'>
                                {t("forms.subtitles.organismoEstatal")}
                              </Divider>
                              <Row gutter={[20]}>
                              {renderFormItemTable({
                                section: dataPepObj.categoria,
                              })}

                              {renderFormItemTable({
                                section: dataPepObj.razonSocial,
                              })}
                              </Row>
                              <Divider orientation='left'>
                                {t("forms.subtitles.personaRelacionada", {var: dataPepObj.razonSocial.val})}
                              </Divider>
                              <Row gutter={[20]}>
                                {renderFormItemTable({
                                  section: dataPepObj.parentesco,
                                  options: optList.parentesco.slice(1),  // Opciones para parentesco
                                })}

                                {renderFormItemTable({
                                  section: dataPepObj.nombre,
                                })}

                                {renderFormItemTable({
                                  section: dataPepObj.tipoDoc,
                                })}

                                {renderFormItemTable({
                                  section: dataPepObj.doc,
                                  validator: docValidator(dataPepObj.tipoDoc.val, "persona")
                                })}
                              </Row>
                              <Row gutter={[20]}>
                                {renderFormItemTable({
                                  section: dataPepObj.cargo,
                                })}
                                {renderFormItemTable({
                                  section: dataPepObj.fechaTermino,
                                })}
                              </Row>
                            </Row>
                          }
                          {funcionariosPublicos.records.val.length < 1 &&
                            validarRegistros && (
                              <Col
                                span={24}
                                style= {{color: 'red'}}
                                className="missing-registers ant-form-explain"
                              >
                                {t("messages.aml.registersRequired", {ns: 'translations'})}
                              </Col>
                          )}
                          {format ==='html' && 
                            <Row>
                              <Col className="addRelation" xl={3}>
                                <Button
                                  type="primary"
                                  htmlType="button"
                                  onClick={() => handleOnAddAttrTableLocal('dataPepObj', 'funcionariosPublicos')}
                                  icon="plus"
                                >
                                  {t("forms.añadir")}
                                </Button>
                              </Col>
                              <Col className="addRelation" xl={3}>
                                <Button
                                  type="primary"
                                  htmlType="button"
                                  icon="delete"
                                  onClick={() => handleOnClear('dataPepObj')}
                                >
                                  {t("forms.limpiar")}
                                </Button>
                              </Col>
                            </Row>
                          }
                        
                          {funcionariosPublicos.records.val.length > 0 && format === "html" ? (
                            <Table
                              columns={funcionariosPublicosColumns}
                              dataSource={funcionariosPublicos.records.val}
                              size="middle"
                              pagination={false}
                            />
                          ) : (
                            toDescriptionsPdf(funcionariosPublicos.records.val, dataPepObj, apiForm.typeSol)
                          )}
                        </>
                      )}

                      <Row className="lineamiento subheader">
                        <Col xl={24}>{t("forms.titles.relacionFundaciones")}</Col>
                      </Row>
                      <Row className="summary">
                        <Col span={21}>
                          <p>
                            {t("forms.sonda.dir.relacionFundaciones.text1", {ns:'formsSonda'})}
                          </p>
                        </Col>
                        {renderFormItem({
                          label: "",
                          colClassName: "switch-col",
                          itemClassName: "radio-item",
                          name: relacionFundaciones.hasRecords.id,
                          labelCol: 0,
                          wrapperCol: 0,
                          offset: 0,
                          initialValue: relacionFundaciones.hasRecords.val,
                          rules: [
                            {
                              required: true,
                              message: t("messages.aml.dontForgetSelect", {ns: 'translations'}),
                            },
                          ],
                          wrapperCols: 3,
                          item: (
                            <Radio.Group
                              onChange={({ target }) =>
                                handlerOnChangeObjAttr(relacionFundaciones.hasRecords.id, target.value)
                              }
                            >
                              <Radio style={radioStyle} value={true}>
                                {t("forms.options.si")}
                              </Radio>
                              <Radio style={radioStyle} value={false}>
                                {t("forms.options.no")}
                              </Radio>
                            </Radio.Group>
                          ),
                        })}
                      </Row>

                      {relacionFundaciones.hasRecords.val && (
                        <>
                          {format === 'html' &&
                            <Row gutter={[20]}>
                              <Divider orientation='left'>
                                {t("forms.subtitles.datosInstitucion")}
                              </Divider>
                              {renderFormItemTable({
                                section: dataRelFundObj.tipoInstitucion,
                              })}

                              {renderFormItemTable({
                                section: dataRelFundObj.nombreInstitucion,
                              })}

                              {renderFormItemTable({
                                section: dataRelFundObj.tipoDocEmp,
                                options: optList.tipoDoc,
                              })}

                              {renderFormItemTable({
                                section: dataRelFundObj.docEmp,
                                validator: docValidator(dataRelFundObj.tipoDocEmp.val, "empresa")
                              })}

                              <Divider orientation='left'>
                                {t("forms.subtitles.personaRelacionada", {var: dataRelFundObj.nombreInstitucion.val})} 
                              </Divider>
                              {renderFormItemTable({
                                section: dataRelFundObj.parentesco,
                              })}

                              {renderFormItemTable({
                                section: dataRelFundObj.nombre,
                              })}

                              {renderFormItemTable({
                                section: dataRelFundObj.tipoDoc,
                              })}

                              {renderFormItemTable({
                                section: dataRelFundObj.doc,
                                validator: docValidator(dataRelFundObj.tipoDoc.val, "persona")
                              })}

                              {renderFormItemTable({
                                section: dataRelFundObj.cargoOpt,
                              })}

                              {dataRelFundObj.cargoOpt.val === "Otro" && renderFormItemTable({
                                section: dataRelFundObj.otroCargo,
                              })}

                              {renderFormItemTable({
                                section: dataRelFundObj.area,
                              })}
                            </Row>
                          }
                          {relacionFundaciones.records.val.length < 1 &&
                            validarRegistros && (
                              <Col
                                span={24}
                                style= {{color: 'red'}}
                                className="missing-registers ant-form-explain"
                              >
                                {t("messages.aml.registersRequired", {ns: 'translations'})}
                              </Col>
                          )}
                          {format ==='html' && 
                            <Row>
                              <Col className="addRelation" xl={3}>
                                <Button
                                  type="primary"
                                  htmlType="button"
                                  onClick={() => handleOnAddAttrTableLocal('dataRelFundObj', 'relacionFundaciones')}
                                  icon="plus"
                                >
                                  {t("forms.añadir")}
                                </Button>
                              </Col>
                              <Col className="addRelation" xl={3}>
                                <Button
                                  type="primary"
                                  htmlType="button"
                                  icon="delete"
                                  onClick={() => handleOnClear('dataRelFundObj')}
                                >
                                  {t("forms.limpiar")}
                                </Button>
                              </Col>
                            </Row>
                          }
                        
                          {relacionFundaciones.records.val.length > 0 && format === "html" ? (
                            <Table
                              columns={relacionFundacionesColumns}
                              dataSource={relacionFundaciones.records.val}
                              size="middle"
                              pagination={false}
                            />
                          ) : (
                            toDescriptionsPdf(relacionFundaciones.records.val, dataRelFundObj, apiForm.typeSol)
                          )}
                        </>
                      )}
                      
                      <Row className="subheader">
                        {t("forms.titles.confidencialidad")}
                      </Row>
                      <Row className="summary">
                        <Col span={24}>
                          <p>
                            {t("forms.sonda.dir.confidencialidad.text1", {ns:'formsSonda'})}
                          </p>
                          <p>
                            {t("forms.sonda.dir.confidencialidad.text2", {ns:'formsSonda'})}
                          </p>
                        </Col>
                      </Row>
                      <Row gutter={[60, 30]} className="summary">
                        <Col span={8}>
                          <p>
                            {t("forms.sonda.dir.confidencialidad.text3", {ns:'formsSonda'})}
                          </p>
                        </Col>
                        <Col span={8}>
                          <p>
                            {t("forms.sonda.dir.confidencialidad.text4", {ns:'formsSonda'})}
                          </p>
                        </Col>
                        <Col span={8}>
                          <p>
                            {t("forms.sonda.dir.confidencialidad.text5", {ns:'formsSonda'})}
                          </p>
                        </Col>
                      </Row>
                      <Row className="subheader">
                        {t("forms.titles.responsabilidadPersonasJuridicas")}
                      </Row>
                      <Row className="summary">
                        <Col span={24}>
                          <p>
                            {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text1", {clientName, ns:'formsSonda'})}
                            <br/><br/>
                              <strong>{t("forms.paises.argentina")}</strong>: {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text2", { ns: 'formsSonda' })}<br />
                              <strong>{t("forms.paises.brasil")}</strong>: {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text3", { ns: 'formsSonda' })}<br />
                              <strong>{t("forms.paises.colombia")}</strong>: {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text4", { ns: 'formsSonda' })}<br />
                              <strong>{t("forms.paises.costa_rica")}</strong>: {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text5", { ns: 'formsSonda' })}<br />
                              <strong>{t("forms.paises.chile")}</strong>: {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text6", { ns: 'formsSonda' })}<br />
                              <strong>{t("forms.paises.ecuador")}</strong>: {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text7", { ns: 'formsSonda' })}<br />
                              <strong>{t("forms.paises.estados_unidos")}</strong>: {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text8", { ns: 'formsSonda' })}<br />
                              <strong>{t("forms.paises.guatemala")}</strong>: {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text9", { ns: 'formsSonda' })}<br />
                              <strong>{t("forms.paises.mexico")}</strong>: {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text10", { ns: 'formsSonda' })}<br />
                              <strong>{t("forms.paises.panama")}</strong>: {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text11", { ns: 'formsSonda' })}<br />
                              <strong>{t("forms.paises.peru")}</strong>: {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text12", { ns: 'formsSonda' })}<br />
                              <strong>{t("forms.paises.uruguay")}</strong>: {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text13", { ns: 'formsSonda' })}<br />
                          </p>
                          <p>
                            {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text14", {ns:'formsSonda'})}
                          </p>
                          <ul>
                            <li>
                              {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text15", {ns:'formsSonda'})}
                            </li>
                            <li>
                              {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text16", {clientName, ns:'formsSonda'})}
                            </li>
                            <li>
                              {t("forms.sonda.dir.responsabilidadPersonasJuridicas.text17", {clientName, ns:'formsSonda'})}
                            </li>
                          </ul>
                        </Col>
                      </Row>
                      <Row className="subheader">
                        <Col xl={24}>
                          {t("forms.titles.declaracionResponsabilidad")}
                        </Col>
                      </Row>
                      <Row className="summary">
                        <p>
                          {t("forms.sonda.dir.declaracionResponsabilidad.text1", {clientName, ns:'formsSonda'})}
                        </p>
                        <p>
                          {t("forms.sonda.dir.declaracionResponsabilidad.text2", {clientName, ns:'formsSonda'})}
                        </p>
                      </Row>
                    </div>
                  )}
                  {apiForm.status !== "SENT" && format === 'html' &&
                    <Row className="button-row">
                      <Col className="submitTrabajador" xl={24}>
                        <Button type="primary" onClick={handleSubmit} icon='file-protect'>
                          { hasSign ? t("forms.buttons.sign") : t("forms.buttons.send") }
                        </Button>
                      </Col>
                    </Row>
                  }
                </Form>
              </div>
            ) : (
              <h2 style={{ textAlign: "center" }}>{t("forms.messages.notFoundForm")}</h2>
            )}
          </div>
        )}
      </div>
    </FormLayout>
  );
};

export default withRouter(Form.create()(FormDir));
